import { render, staticRenderFns } from "./BetaFeatures.vue?vue&type=template&id=cdb911fa&scoped=true&"
import script from "./BetaFeatures.vue?vue&type=script&lang=js&"
export * from "./BetaFeatures.vue?vue&type=script&lang=js&"
import style0 from "./BetaFeatures.vue?vue&type=style&index=0&id=cdb911fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb911fa",
  null
  
)

export default component.exports